// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"noodle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 12V11H3V12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16 4L17 4M17 4H20M17 4V10M20 4H21M20 4V10M4 10C4 7.23858 6.23858 5 9 5C11.7614 5 14 7.23858 14 10V11H4L4 10ZM7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10V11H7V10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 12V11H3V12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const NoodleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'noodle',
    ref,
    icon: element,
  },
));

NoodleIcon.displayName = 'NoodleIcon';

export default NoodleIcon;
